module.exports = __webpack_public_path__ + "75f86c7f02d065553c923f84149e6074.svg";